module.exports = __webpack_public_path__ + "img/family_picture.1cf5d5bf.jpg";